import script from "./ChipTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChipTag.vue?vue&type=script&setup=true&lang=ts"

import "./ChipTag.vue?vue&type=style&index=0&id=3179413b&lang=scss"

const __exports__ = script;

export default __exports__